module.exports = __webpack_public_path__ + "static/img/100088.2d864e22.png";